module.exports = require('./dist');

